<template>
  <div>
    <v-container fluid>
      <div style="margin-bottom: 2.5em">
        <h5>ลูกค้าที่มีคะแนนสะสมเยอะที่สุด</h5>
      </div>
      <v-layout row wrap>
        <v-flex sm6 xs12 class="mb-4">
          <div>
            <p class="title">Current Point</p>
          </div>
          <div>
            <div v-for="(item, k) in data" :key="k">
              <v-layout @click="showCustomerDetail(item.id)" row wrap>
                <v-flex xs2 lg1>
                  <v-avatar>
                    <v-img :src="item.profile_pic"></v-img>
                  </v-avatar>
                </v-flex>
                <v-flex xs9 lg8 class="pl-3">
                  <div>
                    {{ item.firstname }} {{ item.lastname }}
                    <span style="float: right; color: grey; font-weight: 600">{{
                      item.point | numberFormat
                    }}</span>
                  </div>
                  <v-progress-linear
                    style="border-radius: 5px; margin-top: 0"
                    color="primary"
                    height="15"
                    :value="getPercent(item.point)"
                  ></v-progress-linear>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-flex>
        <v-flex sm6 xs12>
          <div>
            <p class="title">Total Point</p>
          </div>
          <div>
            <div v-for="(item, k) in totalpoint" :key="k">
              <v-layout @click="showCustomerDetail(item.id)" row wrap>
                <v-flex xs2 lg1>
                  <v-avatar>
                    <v-img :src="item.profile_pic"></v-img>
                  </v-avatar>
                </v-flex>
                <v-flex xs9 lg8 class="pl-3">
                  <div>
                    {{ item.firstname }} {{ item.lastname }}
                    <span style="float: right; color: grey; font-weight: 600">{{
                      item.totalpoint | numberFormat
                    }}</span>
                  </div>
                  <v-progress-linear
                    style="border-radius: 5px; margin-top: 0"
                    color="primary"
                    height="15"
                    :value="getPercentTotal(item.totalpoint)"
                  ></v-progress-linear>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showCustomer" width="800">
      <v-card>
        <CustomerDetail v-if="showCustomer" v-model="currentuserid">
          <div slot="header" class="text-xs-right">
            <v-btn flat fab small class="extra-small" @click="showCustomer = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </CustomerDetail>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from './DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CustomerDetail from '@/components/view/dashboard/CustomerDetail.vue'

export default {
  components: {
    CustomerDetail,
    DateFilter
  },
  data() {
    return {
      data: [],
      currentuserid: '',
      showCustomer: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    totalpoint() {
      return this.data.sort((a, b) => parseFloat(b.totalpoint) - parseFloat(a.totalpoint))
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    showCustomerDetail(id) {
      this.currentuserid = id
      this.showCustomer = true
    },
    getData() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      api.getsahapantoprewardpoint(data, (err, response) => {
        if (response.responsecode == 200) {
          this.data = response.data
        }
      })
    },
    getPercent(point) {
      var total = 0
      this.data.map((el) => (total += parseFloat(el.point)))
      return (point / total) * 100
    },
    getPercentTotal(point) {
      var total = 0
      this.data.map((el) => (total += parseFloat(el.totalpoint)))
      return (point / total) * 100
    },
    onDateChanged() {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/SahapanTopRewardPoint.vue